import { getBaseQuery, getBaseUrl } from '../api.util.ts'
import { createApi } from '@reduxjs/toolkit/query/react'
import {
  BlockLeaveCreateRequest,
  BlockLeaveCreateResponse,
  BlockLeaveDeleteRequest,
  BlockLeaveDeleteResponse,
  BlockLeaveUpdateRequest,
  BlockLeaveUpdateResponse,
  GetBlockLeaveRequest,
  GetBlockLeaveResponse,
} from './block-leave-api.def.ts'

const interfaceName = 'block-leave'

export const blockLeaveApi = createApi({
  reducerPath: 'blockLeaveApi',
  baseQuery: getBaseQuery(getBaseUrl(interfaceName)),
  tagTypes: ['block-leave'],
  endpoints: (build) => ({
    getBlockLeave: build.query<GetBlockLeaveResponse, GetBlockLeaveRequest>({
      query: (params) => ({
        url: `/user/${params.userId}`,
        method: 'GET',
        params: params,
      }),
      providesTags: ['block-leave'],
    }),
    createBlockLeave: build.mutation<
      BlockLeaveCreateResponse,
      BlockLeaveCreateRequest
    >({
      query: (payload) => ({
        url: '/',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['block-leave'],
    }),
    updateBlockLeave: build.mutation<
      BlockLeaveUpdateResponse,
      BlockLeaveUpdateRequest
    >({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['block-leave'],
    }),
    deleteBlockLeave: build.mutation<
      BlockLeaveDeleteResponse,
      BlockLeaveDeleteRequest
    >({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'DELETE',
        body: payload,
      }),
      invalidatesTags: ['block-leave'],
    }),
  }),
})

export const {
  useGetBlockLeaveQuery,
  useCreateBlockLeaveMutation,
  useUpdateBlockLeaveMutation,
  useDeleteBlockLeaveMutation,
} = blockLeaveApi
